import { render } from "./Paragraph.vue?vue&type=template&id=c293cd76&ts=true"
import script from "./Paragraph.vue?vue&type=script&lang=ts"
export * from "./Paragraph.vue?vue&type=script&lang=ts"

import "./Paragraph.vue?vue&type=style&index=0&id=c293cd76&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__